import React from "react";
import locale from "@bonliva-crm/locale";
import Select from "@components/Select";
import { projectsToOptions } from "./projectsToOptions";
import { useRegularProjects } from "@hooks";

type Props = {
  disabled?: boolean;
  error?: boolean;
  fullWidth?: boolean;
  value: string[];
  onChange(value: string[]): void;
};

export function ProjectMultiSelect(props: Props) {
  const { regularProjects, loading } = useRegularProjects();
  const options = projectsToOptions(regularProjects);

  return (
    <Select
      {...props}
      multi
      optionType={"checkboxTwoLine"}
      label={locale.Project}
      options={options}
      disabled={loading || props.disabled}
      onChange={(v) => props.onChange(v)}
    />
  );
}
